import React from 'react';
import { Button, Progress } from 'antd';
import './index.scss';
export const UploadSchedule = (props) => {
    const percent: number = props.progress||0;
    // tslint:disable-next-line: jsx-wrap-multiline
    return (
        <div className="upload-schedule">
            <div className="upload-schedule-name">{props.name}</div>
            <div className="upload-progress-button-box">
                <div className="upload-progress">
                    <Progress percent={percent} showInfo={true} />
                </div>
                <div className="upload-progress-button">
                    {
                        // tslint:disable-next-line: jsx-no-lambda
                        <Button
                            disabled={props.status !== 'done'}
                            onClick={() => props.fileInput.click()}>
                            重新上传
                        </Button>
                    }
                    <Button
                        disabled={props.status !== 'done'}
                        onClick={props.delVideo}>
                        删除视频
                    </Button>
                </div>
            </div>
            <div className="upload-schedule-info-count">
                {/* {props.loaded === props.videoSize && props.status === 'pending' && (
                    <div>
                        <p  style={{display:'flex'}}>
                            已上传: {percent}%，转码中...
                            <span style={{paddingLeft:'20px'}}></span>
                            <img
                                src="https://p.ampmake.com/fed/image/svg+xml/f92a82c16181c38359b027f898ff0135.svg"
                                alt=""
                                srcset=""
                                style={{height:'16px'}}
                            />
                        </p>
                        <p>
                            根据视频大小，转码可能需要1-10分钟不等，请勿关闭当前页面。转码完成后，下方界面中会展示封面图
                        </p>
                    </div>
                )}
                {props.status === 'done' && (
                    <div>
                        <p>转码完成</p>
                    </div>
                )} */}
                {props.loaded < props.videoSize && (
                    <p>
                        已上传: {percent}%，<span style={{paddingLeft:'20px'}}></span>{props.loaded}MB/{props.videoSize}MB
                    </p>
                )}
                  {props.loaded === props.videoSize && (
                    <p>
                        上传完成<span style={{paddingLeft:'20px'}}></span>{props.loaded}MB/{props.videoSize}MB
                    </p>
                )}
            </div>
        </div>
    );
};
